import { CDS_API_BASE_URL, UNIFIED_API_BASE_URL } from '$lib/config/apienv';

export const UNIFIED_API_ENDPOINT = `${UNIFIED_API_BASE_URL}/unified/v3`;
export const CDS_API_ENDPOINT = `${CDS_API_BASE_URL}/swish-cds/content`;
